import {
  AssociatedContact,
  IAssociatedContact,
} from '@app/models/AssociatedContact'
import { List, Record } from 'immutable'
import { CommissionSplit, ICommissionSplit } from './CommissionSplit'
import { IPrice, Price } from './Price'

export enum GoalType {
  Education = 0,
  Family = 1,
  Financial = 2,
  Health = 3,
  Social = 4,
  Spiritual = 5,
  Work = 6,
  Other = 7,
}

export enum GoalSortOption {
  Title = 0,
  DueDate = 1,
  Type = 2,
}

export interface IGoal {
  readonly mentions: List<string>
  readonly type: GoalType
  readonly text: string
  readonly dueDate?: number
  readonly contact: IAssociatedContact
  readonly isComplete: boolean
  readonly note: string
}

const GoalRecord = Record({
  contact: undefined,
  dueDate: undefined,
  isComplete: false,
  mentions: List<string>(),
  note: '',
  text: '',
  type: '',
})

export class Goal extends GoalRecord implements IGoal {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Goal()
    }

    const { contact, mentions, ...rest } = initialState

    return new Goal({
      contact: AssociatedContact.fromJS(contact),
      mentions: List(mentions || []),
      ...rest,
    })
  }

  public readonly mentions: List<string>
  public readonly type: GoalType
  public readonly text: string
  public readonly dueDate?: number
  public readonly contact: AssociatedContact
  public readonly isComplete: boolean
  public readonly note: string

  constructor(props?: Partial<Goal>) {
    props ? super(props) : super()
  }
}
